export const EpicFhirAuthMode_Cert = 'cert';
export const EpicFhirAuthMode_Jwks = 'jwks';
export const EpicFhirAuthModes = [EpicFhirAuthMode_Cert, EpicFhirAuthMode_Jwks];
//# sourceMappingURL=types.js.map